<!-- Spinner from loading.io *** -->

<div class="loadingio-spinner-dual-ring-gedv3pb3pqo"><div class="ldio-2x6b82d35ti">
  <div></div><div><div></div></div>
  </div></div>
  <style type="text/css">
  @keyframes ldio-2x6b82d35ti {
    0% { transform: rotate(0) }
    100% { transform: rotate(360deg) }
  }
  .ldio-2x6b82d35ti div { box-sizing: border-box!important }
  .ldio-2x6b82d35ti > div {
    position: absolute;
    width: 144px;
    height: 144px;
    top: 28px;
    left: 28px;
    border-radius: 50%;
    border: 16px solid #000;
    border-color: #dc5c5c transparent #dc5c5c transparent;
    animation: ldio-2x6b82d35ti 1s linear infinite;
  }
  .ldio-2x6b82d35ti > div:nth-child(2) { border-color: transparent }
  .ldio-2x6b82d35ti > div:nth-child(2) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
  }
  .ldio-2x6b82d35ti > div:nth-child(2) div:before, .ldio-2x6b82d35ti > div:nth-child(2) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    top: -16px;
    left: 48px;
    background: #dc5c5c;
    border-radius: 50%;
    box-shadow: 0 128px 0 0 #dc5c5c;
  }
  .ldio-2x6b82d35ti > div:nth-child(2) div:after {
    left: -16px;
    top: 48px;
    box-shadow: 128px 0 0 0 #dc5c5c;
  }
  .loadingio-spinner-dual-ring-gedv3pb3pqo {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: white;
  }
  .ldio-2x6b82d35ti {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-2x6b82d35ti div { box-sizing: content-box; }
  /* generated by https://loading.io/ */
  </style>
